module.exports = __webpack_public_path__ + "img/q2a4.67953501.png";